enum Colors {
  PRIMARY_MAIN = '#A03A7E',
  PRIMARY_SHADE = '#6A5DCC',
  PRIMARY_ACCENT = '#662B5C',

  SECONDARY_MAIN = '#0EABBC',
  SECONDARY_SHADE = '#42D1E0',

  DANGER_MAIN = '#D6584D',
  DANGER_SHADE = '#F6857B',

  WARNING_MAIN = '#F2AD27',
  WARNING_SHADE = '#FFCE6F',

  BLUE = '#1976d2',
  COLOR_DARK_1 = '#000000',
  COLOR_DARK_2 = '#202329',
  COLOR_DARK_3 = '#555B68',
  COLOR_DARK_3_05 = '#555B68',
  COLOR_DARK_4 = '#9D9FA4',
  COLOR_DARK_5 = '#31353D',
  COLOR_DARK_6 = '#17181C',

  WHITE = '#FFFFFF',
  COLOR_WHITE_2 = '#FEFEFE',
  COLOR_WHITE_3 = '#F2F2F2',
  COLOR_WHITE_TEXT = '#FEFEFE',

  COLOR_ICON_GREY = '#808998',
  COLOR_BLACK = '#1D1D1D',
  COLOR_TEXT_BG = '#EDC2E2',
  COLOR_TEXT_MASK = '#AA779F',
  COLOR_TEXT_GREEN = '#3AA05C',
}

export default Colors;
